














  import { Component } from 'vue-property-decorator'
  import { mixins } from 'nuxt-property-decorator'
  import { Wishlist } from '@one/types/dist/orderpath/app'
  import { namespace } from 'vuex-class'
  import CurrentProductMixin from '~/mixins/CurrentProduct'
  import AddToCartMixin from '~/mixins/AddToCartMixin'

  const products = namespace('products')
  const stocks = namespace('stocks')
  const cart = namespace('cart')
  const wishlist = namespace('wishlist')

  interface AddToCartOrWishlistEvent {
    id?: string
    quantity: number
  }
  interface LocalBasicWishlistOrCart {
    id: string
    name: string
  }

  @Component({
    components: {
      OneProductTileRightActions: () =>
        import('~/components/organisms/product/OneProductTileRightActions.vue'),
    },
  })
  export default class OneProductTechnicalDataSection extends mixins<
    AddToCartMixin,
    CurrentProductMixin
    >(AddToCartMixin, CurrentProductMixin) {
    @products.Getter getAttributesValue: any
    @products.Getter getProductOrderUnit: any
    @stocks.Getter getProductOrderQuantityInWarehouse: any
    @stocks.Getter getProductWarehouse: any
    @stocks.Getter isEnoughProductWithBlockLabelInStock: any
    @stocks.Getter getDefaultWarehouseId: any
    @stocks.Getter getCentralWarehouse: any
    @stocks.Getter getWarehouse: any
    @stocks.Getter getProductStocks: any
    @cart.Getter getBasicCarts: any
    @cart.Getter getCurrentCartId: any
    @cart.Getter getCurrentCart: any
    @cart.Getter getBasicCartById: any
    @wishlist.Action addProductToWishlist: any
    @wishlist.Getter getCurrentWishlistId: any
    @wishlist.Getter getBasicWishlists: any
    @wishlist.Getter getBasicWishlistById: any
    @wishlist.Getter getCurrentWishlist: any
    @wishlist.Getter getWishlistProduct: any

    get carts(): Array<LocalBasicWishlistOrCart> {
      if (this.$auth.isAuthenticated) {
        return Object.keys(this.getBasicCarts).map((id: string) => this.getBasicCartById(id))
      }
      return (
        (this.getCurrentCart && [
          {
            id: this.getCurrentCartId,
            name: this.getCurrentCart.name,
          },
        ]) ||
        []
      )
    }

    get wishlists(): Array<Wishlist.Responses.BasicWishlist | LocalBasicWishlistOrCart> {
      if (this.$auth.isAuthenticated) {
        return Object.keys(this.getBasicWishlists).map((id: string) =>
          this.getBasicWishlistById(id),
        )
      }
      return (
        (this.getCurrentWishlist && [
          {
            id: this.getCurrentWishlistId,
            name: this.getCurrentWishlist.name,
          },
        ]) ||
        []
      )
    }

    get unit() {
      return this.getProductOrderUnit(this.$product?.id)
    }

    onAddToCart(event: AddToCartOrWishlistEvent) {
      this.$wait.start('add-to-cart')
      const payload = {
        cartId: event.id ?? this.getCurrentCartId,
        productId: this.$product!.id,
        amountOfProducts: event.quantity,
      }
      this.addToCart(
        payload.productId,
        payload.amountOfProducts,
        'product-page',
        payload.cartId ? payload.cartId : this.getCurrentCartId,
      ).finally(() => this.$wait.end('add-to-cart'))
    }

    onAddToWishlist(event: AddToCartOrWishlistEvent) {
      const payload = {
        wishlistId: event.id ?? this.getCurrentWishlistId,
        productId: this.$product!.id,
        amountOfProducts: event.quantity,
      }
      this.addProductToWishlist({
        wishlistId: payload.wishlistId || this.getCurrentWishlistId,
        newProduct: {
          productId: payload.productId,
          amountOfProducts: payload.amountOfProducts,
        },
      })
        .then(() => {
          this.$notify({
            group: 'alert',
            type: 'success',
            text: this.$t('product_page.alert_added_to_wishlist') as string,
          })
          const addedProduct = this.getWishlistProduct(this.getCurrentWishlistId)(payload.productId)
          this.$gtm.addToWishlist(
            {
              item_id: addedProduct.id,
              item_name: addedProduct.name,
              item_list_name: this.getCurrentWishlist.name,
              item_brand: addedProduct.brand?.name || '',
              category: this.$routes.getCategoryPath(addedProduct.canonicalCategory) || '',
              price: addedProduct.prices?.unitNet || 0,
              discount: addedProduct.prices?.catalogPriceNet - addedProduct.prices?.unitNet,
              quantity: event.quantity || 0,
            },
            addedProduct?.prices.unitNet * event.quantity,
          )
        })
        .catch((err: any) => {
          console.warn(err)
          this.$notify({
            group: 'alert',
            type: 'error',
            text: this.$t('errors.add_to_wishlist_error') as string,
          })
        })
    }
  }
